module.exports = __webpack_public_path__ + "img/goodstracing_2.a2fa6a4d.jpg";